export default __webpack_public_path__ + "static/media/AMS House History_Dark2.0e060ada.svg";